import { useState, useEffect } from 'react';

/**
 * 跨過本地午夜時強制重繪一次。
 *
 * 「今天 / 昨天」這類以日曆日為基準的文字（聊天室列表的最後訊息時間、訊息串的跨日分隔線）
 * 都是純函式算出來的，沒有自己的計時器。使用者把頁面開著跨過午夜就會看到昨天 23:50 的
 * 最後訊息仍顯示成「23:50」——看起來像剛剛才傳的，比分隔線寫錯更容易誤導。
 *
 * 只在頁面層掛一個 timer 統一重繪，比讓每一列各自計時便宜得多；
 * 相對時間（useRelativeTime）本身已有 ticker，不需要這個。
 */
export function useLocalMidnightTick() {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const now = new Date();
    // 下一個本地午夜。用本地欄位建構，DST 當天也會落在正確的那個瞬間
    const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const id = setTimeout(() => setTick((n) => n + 1), nextMidnight.getTime() - now.getTime());
    return () => clearTimeout(id);
    // 依賴 tick：每次醒來後重新排下一個午夜，跨日後自動接續
  }, [tick]);
}
